export const importKeys = {
  all: ['imports'] as const,
  list: () => [...importKeys.all, 'list'] as const,
  detail: (id: string) => [...importKeys.all, 'detail', id] as const,
  /** Mapping targets: a bank's stage catalogue and the employer master (searched). */
  stages: (bankId: string) => [...importKeys.all, 'stages', bankId] as const,
  employers: (q: string) => [...importKeys.all, 'employers', q] as const,
  /** Mapping targets of bank employer lists: the bank's employer categories. */
  categories: (bankId: string) => [...importKeys.all, 'categories', bankId] as const,
};
